var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPol2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43216 44.3205C0.928472 44.6511 -0.369205 43.2299 0.0963378 41.7624L12.5936 2.36729C13.0591 0.899764 14.9387 0.486524 15.9769 1.62346L43.8454 32.1439C44.8835 33.2809 44.3016 35.1153 42.7979 35.4459L2.43216 44.3205Z",
    fill: "#032250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol2D);
export default __webpack_public_path__ + "static/media/pol2d.e155b7d9c35bb7d02b85bd595671703e.svg";
export { ForwardRef as ReactComponent };